export const formatObjectToStyle = styleObject => {
  if (!styleObject) return ''
  return styleObject
    .filter(([, v]) => v)
    .map(([k, v]) => `${k}: ${v}`)
    .join(';')
}
